
import React from 'react';
import { AppTab } from '../types';

interface NavbarProps {
  activeTab: AppTab;
  setActiveTab: (tab: AppTab) => void;
  hasUpdate?: boolean;
}

const Navbar: React.FC<NavbarProps> = ({ activeTab, setActiveTab, hasUpdate }) => {
  const tabs: { id: AppTab; label: string; icon: string }[] = [
    { id: 'dashboard', label: 'Beranda', icon: '🏠' },
    { id: 'chat', label: 'Tanya', icon: '💬' },
    { id: 'toolkit', label: 'Siaga', icon: '🎒' },
    { id: 'contacts', label: 'Kontak', icon: '📞' },
    { id: 'info', label: 'Info', icon: 'ℹ️' },
  ];

  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 px-4 py-3 flex justify-between items-center shadow-2xl z-50">
      {tabs.map((tab) => (
        <button
          key={tab.id}
          onClick={() => setActiveTab(tab.id)}
          className={`flex flex-col items-center gap-1 transition-all flex-1 relative ${
            activeTab === tab.id ? 'text-red-600 scale-110 font-bold' : 'text-gray-400'
          }`}
        >
          {tab.id === 'info' && hasUpdate && (
            <span className="absolute top-0 right-[25%] w-2.5 h-2.5 bg-red-500 rounded-full border border-white animate-pulse z-10"></span>
          )}
          <span className="text-xl">{tab.icon}</span>
          <span className="text-[9px] uppercase tracking-wider font-bold">{tab.label}</span>
        </button>
      ))}
    </nav>
  );
};

export default Navbar;
